<template>
  <div>
    <base-header pageName="EP 일정 상세" :prevBtnShow="true" :popup="true"></base-header>

    <section id="wrap">
        <div class="planner">
            <p>
                <em :class="{ epLv: 'COG01' == userInfo.orgnzPstn, epLv1: 'COG02' == userInfo.orgnzPstn, epLvA1: 'COGA2' == userInfo.orgnzPstn, epLv2: 'COG03' == userInfo.orgnzPstn, epLv3: 'COG04' == userInfo.orgnzPstn, epLv4: 'COG05' == userInfo.orgnzPstn, epLv5: 'COG06' == userInfo.orgnzPstn}"></em>
                <strong>{{userInfo.userName}} </strong>
                <i>{{userInfo.userid}}</i>
            </p>
            <dl v-for="(mySchedule,index) in myScheduleList" v-bind:key="index">
                <dt v-if="isNotSameDay(index)">{{ mySchedule.sttDt }}</dt>
                <dd>
                    <em>{{ mySchedule.scdlDivNm }}</em>
                    <p>
                        <em v-if="mySchedule.allYn =='N'">{{ mySchedule.sttHr }} ~ {{ mySchedule.endHr }}</em>
                        <span><i>{{ mySchedule.custNm }}</i>님</span>
                    </p>
                    <span class="radio">
                        <input @click="selectSchedule(mySchedule.sqno)" type="radio" name="selectedSchedule" :id="index" :value="index">
                        <label :for="index"></label>
                    </span>
                </dd>
            </dl>
            <!-- 검색 결과 실패시-->
            <infinite-loading @infinite="infiniteHandler" spinner="waveDots" ref="InfiniteLoading">
              <div slot="no-more"></div>
              <div slot="no-results">
                <div class="search-resutl-None">
                    <p>등록된 일정이 없습니다.</p>
                </div> 
              </div>
            </infinite-loading>
        </div>
    </section>
  </div>
</template>

<script>
import InfiniteLoading from "vue-infinite-loading";
export default {
  name: "UserScheduleList",
  components: {
    InfiniteLoading
  },
  data() {
    return {
      searchUserid: "",
			tot:0,
			offset: 0,	 //현재 가지고있는 갯수
			size : 10,	//한번에 가져오는 수
      myScheduleList: [],
      userInfo: {
          userid: "",
          userName: "",
          orgnzPstn: "",
          orgnzPstnNm: ""
      }
    };
  },
  methods: {
    infiniteHandler: function($state) {
      var that = this;
      var parameters = {
        searchUserid: this.searchUserid,
        offset: this.offset,
        size: this.size
      };
      this.$api.myschedule.getScheduleListByUserid(parameters)
        .then(function(res) {
      // console.log("UserScheduleList.vue getUserScheduleList res.totCnt", res.totCnt);
      // console.log("UserScheduleList.vue getUserScheduleList res.myScheduleList", res.myScheduleList);
          that.tot = res.totCnt;
          var list = res.myScheduleList;
          if (list.length) {
            that.offset += that.size;
            that.myScheduleList = that.myScheduleList.concat(list);
            $state.loaded();
            if (list.length < that.size) {
              $state.complete();
            }
          } else {
            $state.complete();
          }
        })
        .catch(function(error) {
          alert(error.rtMsg);
        });
    },
    getScheduleListByUserid() { // 해당 직원의 접속한 당일 이후의 일정 목록조회
      this.tot = 0;
			this.offset = 0
			this.size = 10
      this.myScheduleList = [];
      this.$refs.InfiniteLoading.stateChanger.reset();
    },
    getUserInfoByUserid() { // 해당 직원의 정보 조회
      var that = this;
      var params = {searchUserid : this.searchUserid};

      //console.log("UserScheduleList.vue getUserScheduleList that.params", that.params);

      this.$api.myschedule.getUserInfoByUserid(params)
        .then(function(res) {
          //console.log( "UserScheduleList.vue <api.myschedule.getUserInfoByUserid.response>",  res.userInfo );
          that.userInfo = res.userInfo; // 담당자 정보.
        })
        .catch(function(error) {
          alert(error.rtMsg);
        });
    },
    selectSchedule : function(sqno) { // 일정 선택시 부모창에 일정 key 전달.
      //console.log( "UserScheduleList.vue selectSchedule sqno", sqno);
      var child = {
        name: 'acmpscdlsqno-selected',
        data: {acmpScdlSqno:sqno}
      };
      this.$utils.nativeIf.outbound.sendChildData(child);

    },
    isNotSameDay : function(index){ // 앞의 날짜와 다른지 체크
        if(index > 0 && this.myScheduleList[index].sttDt == this.myScheduleList[index-1].sttDt){
          return false;
        }
        return true;
    }
  },
  mounted: function() { //  인스턴스가 마운트 된 직후
    //console.log("UserScheduleList.vue mounted this.$route.params.userid:"+this.$route.params.userid);
    
    // 키값이 넘어온 경우에는 상세조회한다.
    if(!this.$utils.stringUtil.isNull(this.$route.params.userid)){
      this.searchUserid = this.$route.params.userid;
      this.getUserInfoByUserid();
    }
  }
};
</script>
